import React, { useState } from "react";
import { Button } from "./ui/button";
import { Zap } from "lucide-react";
import { UnderConstructionDialog } from "./UnderConstructionDialog";

/**
 * Phase 12: "Switch to LIVE Processing" button shown on non-live module pages
 * (Payroll, AP, AR, POS). All LIVE add-ons are currently Under Construction, so
 * clicking this opens the UnderConstructionDialog. Once an add-on goes live, this
 * component should be extended to check `usage.enabled_addons[addonKey]` and either
 * navigate to the LIVE feature OR open the BillingSubscription add-ons section.
 */
export function LiveProcessingButton({ featureName, dataTestId = "switch-to-live-btn" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        data-testid={dataTestId}
        className="border-amber-500/40 text-amber-700 hover:bg-amber-500/10 hover:text-amber-800 dark:text-amber-300"
        title={`Switch to LIVE ${featureName} processing (Under Construction)`}
      >
        <Zap className="h-4 w-4 mr-1.5" />
        Switch to LIVE Processing
      </Button>
      <UnderConstructionDialog
        open={open}
        onOpenChange={setOpen}
        featureName={`LIVE ${featureName} Processing`}
      />
    </>
  );
}

export default LiveProcessingButton;
